// What the form that adds a counterparty becomes when the counterparty was saved and a file
// then failed to upload (TX-US-0037). The counterparty is on the register, so there is nothing
// left to save: the page names the files that did not follow it, each with its reason, and
// points at the profile, where files are attached.

import { Link } from 'react-router';

export default function FilesNotAttached({ counterparty, items }) {
  return (
    <section className="deal-form">
      <header className="register-header">
        <h2>{counterparty.name}</h2>
      </header>
      <p className="error">
        {counterparty.name} is on the register, but not every file was attached.
      </p>
      <ul className="attachment-list" aria-label="Files not attached">
        {items.map((item) => (
          <li key={item.key} className="pending failed">
            <span className="attachment-name">
              <strong>{item.file.name}</strong>
              <small className="error">{item.error}</small>
            </span>
          </li>
        ))}
      </ul>
      <p>
        <Link to={`/counterparties/${counterparty.counterparty_id}`}>
          Open {counterparty.name} to attach them
        </Link>
      </p>
    </section>
  );
}
